/* eslint-disable react/no-direct-mutation-state */
import React from 'react';
import { connect } from "react-redux";
import { Popup, ToolbarItem as PopupToolbarItem } from 'devextreme-react/popup';
import { injectIntl } from "react-intl";
import Form, { Item as FormItem, SimpleItem, RequiredRule, GroupItem, RangeRule } from 'devextreme-react/form';
import { TextBox } from 'devextreme-react';
import { dxDateBoxProps } from '../../../shared/config/DxFormProperties';
import { withSnackbar } from 'notistack';
import DropDownBox from 'devextreme-react/drop-down-box';
import moment from 'moment';
import * as genericDraftsCrud from '../../../crud/genericDrafts.crud';
import Common from '../../../shared/common';
import { it } from 'date-fns/locale';
import DataSource from "devextreme/data/data_source";

export const RESPONSES = {
    SAVE: 'SAVE',
    CANCEL: 'CANCEL',
};

const radioOptions = [
    { value: 0, display: "No" },
    { value: 1, display: "Yes" }
]
export const recurrencyOptions = [
    { value: 'WEEKLY', display: "Weekly" },
    { value: 'MONTHLY', display: "Monthly" },
];
export const weeklyOptions = [
    { value: 'MONDAY', display: "Monday" },
    { value: 'TUESDAY', display: "Tuesday" },
    { value: 'WEDNESDAY', display: "Wednesday" },
    { value: 'THURSDAY', display: "Thursday" },
    { value: 'FRIDAY', display: "Friday" },
    { value: 'SATURDAY', display: "Saturday" },
    { value: 'SUNDAY', display: "Sunday" },
];


class ContractGenericDraftEditModal extends React.Component {
    constructor(props) {
        super(props);
        this.validatorRef = React.createRef();
        this.validatorName = 'ContractActionEditModalValidator';
        this.formRef = React.createRef();
        this.defaultFields = null;
        // this.workflowsDatasource = this.props.contractTemplate.workflowGroups.reduce((wfArray, wfg) => {
        //     let notifyPossibleWFs = wfg.workflows.filter(wf => (!!wf.config.notifyPossible));
        //     if (notifyPossibleWFs.length > 0) {
        //         wfArray.push(
        //             ...notifyPossibleWFs.map(wf => ({
        //                 value: wf.id,
        //                 display: `[${Common.Lpad(wf.id, 2)}] ${wf.title}`,
        //             }))
        //         );
        //     }
        //     return wfArray;
        // }, []);
        this.clausesDropdown = props.contractQuickMenuItems.reduce((itemsArray, wfGroup) => {
            itemsArray.push(
                ...wfGroup.clauses.map((clause, index) => ({
                    id: itemsArray.length + index + 1,
                    clause: clause.display,
                    group: wfGroup.title,
                    display: clause.display,
                    url: wfGroup.page,
                    wfid: wfGroup.wfid
                }))
            );
            return itemsArray;
        }
            , []);
        this.clausesDataSource =  new DataSource({
            store: {
                type: 'array',
                data: this.clausesDropdown,
                key: 'id',
            },
            group: 'group',
        });
        this.state = {
            isbusy: false,
            changed: false,
            draftNotice: null,
            showRelatedEditor: false
        }

    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps) {
            if (prevProps.draftNotice !== this.props.draftNotice) {
                this.setDraftNotice();
            }
        }
    }


    setDraftNotice = () => {
        if (this.props.draftNotice && this.props.draftNotice.contractgenericdraftid > 0) {
            const draftNotice = { ...this.props.draftNotice };
            this.formData = { ...this.props.draftNotice };
            this.setState({ draftNotice });
        }
        // else {
        //     this.setState({ action: { ...emptyCustomField } });
        // }
    }
    onClose = () => {
        if (this.props.visible) {
            this.props.onDialogResult();
            this.setState({ draftNotice: null, changed: false });
        }
    }
    saveItem = async () => {
        try {
            if (this.formRef?.current) {
                const validationRes = this.formRef.current.instance().validate();
                if (validationRes.isValid) {
                    this.setState({ isbusy: true }, async () => {
                        try {
                            let assignedClause = this.clausesDropdown.find(c => c.id === this.formData.assignedclauseid);
                            let payload = {
                                workflowid: assignedClause.wfid,
                                clause: assignedClause.clause,
                                contractgenericdraftid: this.props.draftNotice.contractgenericdraftid,
                            }
                            await genericDraftsCrud.assign(payload);
                            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'ACTION.MESSAGE.UPDATED' }), { variant: 'success', });
                            this.props.onDialogResult(RESPONSES.SAVE);
                            this.setState({ draftNotice: null, isbusy: false });
                        } catch (err) {
                            this.setState({ isbusy: false });
                            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
                            this.props.onDialogResult(RESPONSES.SAVE);
                        }
                    })
                }
            }
        } catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
        }

        return;
    }
    validateForm = () => {
        const validationResult = this.validatorRef.current.instance().validate();
        return validationResult.isValid;
    }

    formFieldDataChanged = (e) => {
        this.formData = e.component.option("formData");
        if (!this.state.changed) {
            this.setState({ changed: true });
        }
    }


    render() {
        if (!this.props.visible) {
            return null;
        }
        return (
            <Popup
                id='editDraftNoticePopup'
                visible={this.props.visible}
                onHiding={this.onClose}
                dragEnabled={true}
                hideOnOutsideClick={false}
                // showTitle={true}
                // title={"Assign Notice to Workflow"}
                width={800}
                disabled={this.state.isbusy}
                height='auto'>
                <Form
                    ref={this.formRef}
                    formData={this.state.draftNotice}
                    onFieldDataChanged={this.formFieldDataChanged}
                    labelMode='outside'
                    labelLocation='top'
                >
                    <GroupItem>
                        <FormItem
                            colSpan={1}
                            label={{ text: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.FIELD.CLAUSE_TYPE' }) }}
                            dataField="assignedclauseid"
                            editorType='dxSelectBox'
                            editorOptions={{
                                searchEnabled: true,
                                searchExpr: 'display',
                                searchMode: 'contains',
                                searchTimeout: 200,
                                minSearchLength: 0,
                                dataSource: this.clausesDataSource,
                                valueExpr: 'id',
                                displayExpr: 'display',
                                grouped: true,
                            }}
                            isRequired
                        />
                        {
                            !!this.state.draftNotice?.clause && (
                                <FormItem
                                    label={{ text: this.props.intl.formatMessage({ id: 'GENERIC_DRAFTS.SOURCE_CLAUSE_TYPE' }) }}
                                    dataField="clause"
                                    editorType="dxTextBox"
                                    editorOptions={{ maxLength: 100, readOnly: true }}
                                    isRequired
                                />
                            )
                        }
                        <FormItem
                            // defaultValue={this.props.defaultSubject}
                            label={{ text: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.FIELD.SUBJECT' }) }}
                            dataField="subject"
                            editorType="dxTextBox"
                            editorOptions={{ maxLength: 100, readOnly: true }}
                            isRequired
                        />
                        <FormItem
                            label={{ text: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.FIELD.DESCRIPTION' }) }}
                            dataField="description"
                            editorType="dxHtmlEditor"
                            editorOptions={{ height: 100, readOnly: true }}
                        />
                    </GroupItem>

                </Form>
                <PopupToolbarItem location="before"
                    locateInMenu="never"
                    template={`<div style=\"font-size: 20px;\">${ this.props.intl.formatMessage({ id: 'GENERIC_DRAFTS.ASSIGN_MODAL.TITLE' }) }</div>`}
                />
                <PopupToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={{ text: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_CANCEL' }), onClick: this.onClose }}>
                </PopupToolbarItem>
                <PopupToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    disabled={!this.state.changed}
                    options={{
                        text: this.props.intl.formatMessage({ id: 'GENERAL.BUTTON.ASSIGN' }),
                        icon: this.state.isbusy ? 'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--dark' : 'save',
                        onClick: this.saveItem
                    }}>
                </PopupToolbarItem>
            </Popup >
        );
    }
}

const mapStateToProps = store => ({
    contract: store.contract.contract,
    contractTemplate: store.contract.template,
    contractQuickMenuItems: store.contract.quickMenuItems,
});

export default connect(mapStateToProps)(withSnackbar(injectIntl(ContractGenericDraftEditModal)));